<template>
    <div id="app">
    </div>
</template>
<script>
    import LoginService from '../../services/login.service.js';
    export default {
        name: 'RegisterUser',
        data() {
            return {
               
            }
        },
        mixins: [LoginService],
        created() {                 
            this.saveUserInfo('Pankaj.Deharia@gds.ey.com', 'Pankaj','Deharia');
            //if (this.$adal.isAuthenticated()) {
            //    //Fetching User Name , First Name and Family Name from AD
            //    this.saveUserInfo(this.$adal.user.userName, this.$adal.user.profile.given_name,this.$adal.user.profile.family_name);
            //}
        },
        methods: {          
            saveUserInfo(email,firstname,lastname) {               
                this.SaveUserDetails(email,firstname,lastname).then(Response => {
                    if (Response.data =='Updated Successfully') {
                        this.$router.push({ name: 'HomeAD' });
                    }                    
                });
            }
        }
    }
</script>